import React from 'react'
import resume from '../assets/images/pj-brown-resume.pdf'

class Footer extends React.Component {
    render() {
        return (
            <div id="footer" className="justify-align-center">
                <div className="inner">
                    <ul className="icons">
                        <li><a href="https://www.instagram.com/patrickbrown.jr/" target="_blank" rel="noopener noreferrer" className="icon fa-instagram"><span className="label">Instagram</span></a></li>
                        <li><a href="https://www.linkedin.com/in/patrickbrownjr" target="_blank" rel="noopener noreferrer" className="icon fa-linkedin"><span className="label">LinkedIn</span></a></li>
                        <li><a href="https://github.com/patrickbrownjr" target="_blank" rel="noopener noreferrer" className="icon fa-github"><span className="label">Github</span></a></li>
                        <li><a href={resume} download target="_blank" rel="noopener noreferrer" className="icon fa-file-text-o" title="Download Resume"><span className="label">Resume</span></a></li>
                        <li><a href="mailto:contact@patrickbrownjr.me" target="_blank" rel="noopener noreferrer" className="icon fa-envelope-o"><span className="label">Email</span></a></li>
                    </ul>
                    <ul className="copyright">
                    </ul>
                </div>
            </div>
        )
    }
}

export default Footer
